import React, { useEffect, useRef, useState } from "react";
import Player from "@vimeo/player";
import { debounce } from "lodash";

import { Title, VideoContainer, Container } from "./styles";

export const Banner = ({
  vimeoId,
  backgroundImage,
  title,
  rounded = false,
  color = { hex: "#E2D3D1" },
}) => {
  const PROPORTION = 1.78; /* 9:16 */
  const fluid = backgroundImage?.fluid || backgroundImage;
  const player = useRef(null);
  const videoContainer = useRef(null);

  const [w, setW] = useState(0);
  const [h, setH] = useState(0);

  const onResize = () => {
    console.log("resize has happeneed", window.innerWidth, window.innerHeight);
    setW(window.innerWidth);
    setH(window.innerHeight);
  };

  useEffect(() => {
    const onResizeDebounced = debounce(onResize, 200);
    if (typeof window === "object") {
      setW(window.innerWidth);
      setH(window.innerHeight);

      window.addEventListener("resize", onResizeDebounced);

      return () => {
        window.removeEventListener("resize", onResizeDebounced);
      };
    }
  }, []);

  // useEffect(() => {
  //   if (w < 992) {
  //     videoContainer.current.style.height = `${Math.floor(h)}px`;
  //   }
  // }, [h]);

  useEffect(() => {
    if (w !== 0 && h !== 0) {
      if (player.current) {
        player.current.destroy();
      }
      const wProportion = w / h;
      let _w, _h;

      if (wProportion > PROPORTION) {
        _w = w;
        _h = _w / PROPORTION;
      } else {
        _h = h;
        _w = _h * PROPORTION;
      }
      player.current = new Player(videoContainer.current, {
        id: vimeoId,
        controls: false,
        autoplay: true,
        loop: true,
        width: _w,
        height: _h,
        muted: true,
        autopause: false,
      });

      // player.current.on("play", () => {
      //   console.log("ready!");
      //   //setVideoReady(true);
      // });
    }
  }, [w, h]);

  return (
    <Container rounded={rounded}>
      <VideoContainer
        ref={videoContainer}
        src={fluid.src}
        video={true}
        rounded={rounded}
      >
        <Title color={color.hex}>{title}</Title>
      </VideoContainer>
    </Container>
  );
};
